import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { useChallenge } from '../../../hooks';
import { UserAvatar } from '../../user';
import PodiumCard, { podiumOrder, podiumRanksConfig } from './podium-card';
function IndividualLeaderboardPodium({
  event,
  items
}) {
  const {
    getProgressValueWithUnit
  } = useChallenge();
  if (event?.challengeTemplate && event.challengeTemplate.type === 'noTarget') return /*#__PURE__*/React.createElement(React.Fragment, null);
  const loading = items === undefined;
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-end",
    display: {
      xs: 'none',
      md: 'flex'
    },
    flex: "1 1 auto",
    flexDirection: "row",
    gap: 3
  }, podiumOrder.map(({
    itemIndex,
    rank
  }) => {
    const item = items?.[itemIndex];
    return /*#__PURE__*/React.createElement(PodiumCard, {
      avatar: loading || item ? /*#__PURE__*/React.createElement(UserAvatar, {
        size: podiumRanksConfig[rank].avatarSize,
        user: item?.user
      }) : null,
      key: rank,
      rank: rank
    }, /*#__PURE__*/React.createElement(_Typography, {
      noWrap: true,
      fontSize: "0.9375rem",
      fontWeight: 600,
      title: item?.user.username
    }, item ? item.user.username : loading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: "100%"
    }) : '–'), (loading || item && (!item.group || item.group.type !== 'company')) && /*#__PURE__*/React.createElement(_Typography, {
      noWrap: true,
      color: "textSecondary",
      fontSize: "0.8125rem",
      title: item ? item.group.parent ? `${item.group.parent.title} - ${item.group.title}` : item.group.title : ''
    }, item ? item.group.parent ? `${item.group.parent.title} - ${item.group.title}` : item.group.title : /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: "90%"
    })), /*#__PURE__*/React.createElement(_Typography, {
      fontSize: "1.125rem",
      fontWeight: 800
    }, event?.challengeTemplate && item ? getProgressValueWithUnit(event.challengeTemplate.type, item.progressValue) : loading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: 100
    }) : '–'));
  }));
}
export default IndividualLeaderboardPodium;